import * as React from 'react';
import * as s from './Step.css';
import * as T from './Step.types';
import classNames from 'classnames';
import Picture from '@media-ui/core/src/components/Picture';
import ArrLeft from 'Icons/quiz/arr-left.svg';
import LayoutContext from 'Context/LayoutContext';
import Title from '@media-ui/core/src/components/Title';
import Text from '@media-ui/core/src/components/Text';
const Step: React.FunctionComponent<T.IStepProps> = ({ petName, currentStep, onChooseAnswer, onClickBack, reverseContent, totalSteps, image, image_2x, question, description = null, answers, }) => {
    const { isMobile } = React.useContext(LayoutContext);
    const replaceName = (name: string) => (text: string): string => text.replace('{{name}}', petName);
    const replacePetName = replaceName(petName);
    /**
     * Список вариантов ответов
     */
    const renderAnswers = () => {
        if (!answers) {
            return null;
        }
        const answersList = answers.map((answer: T.IStepAnswer) => {
            const { id, text } = answer;
            return (<li key={`answer-item-${id}`} className={s.answer} data-id={id} onClick={onChooseAnswer}>
          {text}
        </li>);
        });
        return <ul className={s['answers-list']}>{answersList}</ul>;
    };
    /**
     * Иллюстрация к вопросу
     */
    const renderImage = () => {
        if (!image && !image_2x) {
            return null;
        }
        return (<Picture objectFit="cover" source={{
                src: image,
            }} srcSet={[
                {
                    media: '(-webkit-min-device-pixel-ratio: 2),(min-resolution: 192dpi)',
                    srcSet: image_2x || '',
                },
            ]}/>);
        return '';
    };
    /**
     * Блок "вопрос n из n"
     */
    const renderQuestionCount = () => {
        if (!currentStep && !totalSteps) {
            return null;
        }
        return (<Text className={s.counter}>{`Вопрос ${currentStep} из ${totalSteps}`}</Text>);
    };
    const stepClass = classNames(s.step, {
        [s['step-reversed']]: reverseContent && !isMobile,
        [s['step-touch']]: isMobile,
    });
    return (<div className={stepClass}>
      {!isMobile && <div className={s.image}>{renderImage()}</div>}
      <div className={s.content}>
        {renderQuestionCount()}
        <Title level="2" className={s['question-title']}>
          {replacePetName(question)}
        </Title>
        {description && !isMobile && (<Text className={s.description}>{replacePetName(description)}</Text>)}
        {renderAnswers()}
        <button className={s['back-button']} onClick={onClickBack}>
          <ArrLeft width="14" height="10"/>
        </button>
      </div>
    </div>);
};
export default Step;
